import axios from 'axios';
import toPairs from 'lodash/toPairs';
import pick from 'lodash/pick';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
/* istanbul ignore file */

const digit = /\d+/i;

export function addKeys(response) {
  if (!response.data.question1) {
    return response;
  }

  const data = toPairs(response.data).map((pair) => ({
    id: pair[0].match(digit)[0],
    key: pair[0],
    question: pair[1]
  }));

  return {
    ...response,
    data
  };
}

export function getPwdComplexityRequirements() {
  return axios.post('/authentication/user/getPwdComplexityRequirements').then(({ data }) => data);
}

export const getPwdComplexityRequirements$ = () =>
  from(axios.post('/authentication/user/getPwdComplexityRequirements')).pipe(
    map(({ data: { data, success } }) => ({ data, success }))
  );

export function getSecurityQuestionsSecured() {
  return axios
    .post('/authentication/user/getSecurityQuestions')
    .then(({ data }) => data)
    .then(addKeys);
}

export const getSecurityQuestionsSecured$ = (payload) =>
  from(axios.post('/authentication/user/getSecurityQuestions', payload)).pipe(
    map(({ data: { data, success } }) => ({ data, success }))
  );

export function getSecurityQuestions(customerCode, userCode) {
  const truncUserCode = userCode.substring(0, 12);
  const truncCustomerCode = customerCode.substring(0, 12);
  return axios
    .post('/authentication/public/user/getSecurityQuestions', {
      customerCode: truncCustomerCode,
      userCode: truncUserCode
    })
    .then(({ data }) => data)
    .then(addKeys);
}

export function validateQAChallenge({ answer1, answer2, answer3, customerCode, userCode }) {
  const truncUserCode = userCode.substring(0, 12);
  const truncCustomerCode = customerCode.substring(0, 12);
  return axios
    .post('/authentication/public/user/resetPassword', {
      answer1,
      answer2,
      answer3,
      customerCode: truncCustomerCode,
      userCode: truncUserCode,

      /** @description this is a part of the api
       * @url http://bfs-lab-stack01comp.saas-n.com:8080/authentication/swagger-ui.html#!/users45resource/resetPasswordUsingPOST_1
       */
      question1Id: 0,
      question2Id: 0,
      question3Id: 0
    })
    .then(({ data }) => data);
}

export function changePassword({
  customerCode,
  newPassword,
  oldPassword,
  redirectToken,
  userCode
}) {
  return axios
    .post('/authentication/user/changePassword', {
      customerCode,
      newPassword,
      oldPassword,
      userCode,
      redirectToken
    })
    .then(({ data }) => data);
}

export const changePassword$ = (payload) =>
  from(axios.post('/authentication/user/changePassword', payload)).pipe(
    map(({ data: { data, success } }) => ({ data, success }))
  );

function allQuestionKeys({ data }) {
  if (!data.success || !data.data.securityQuestions) {
    return data;
  }

  const securityQuestions = data.data.securityQuestions.map((question) => ({
    ...question,
    key: `question-${question.questionId}`
  }));

  return {
    ...data,
    data: {
      ...data.data,
      securityQuestions
    }
  };
}

export function getAllQuestions() {
  return axios.post('/authentication/user/getSecurityQuestionsByLeadBank').then(allQuestionKeys);
}

export const getAllQuestions$ = () =>
  from(axios.post('/authentication/user/getSecurityQuestionsByLeadBank')).pipe(
    map(({ data: { data, success } }) => ({ data, success }))
  );

export function saveAnswers(params) {
  const validParams = pick(params, [
    'customerCode',
    'userCode',
    'question1Id',
    'question2Id',
    'question3Id',
    'answer1',
    'answer2',
    'answer3'
  ]);

  return axios
    .post('/authentication/user/saveSecurityQuestionAnswers', validParams)
    .then(({ data }) => data);
}

export const saveAnswers$ = (payload) =>
  from(axios.post('/authentication/user/saveSecurityQuestionAnswers', payload)).pipe(
    map(({ data: { data, success } }) => ({ data, success }))
  );
